import { render, staticRenderFns } from "./BlogPostEdit.vue?vue&type=template&id=d4919b80&scoped=true&"
import script from "./BlogPostEdit.vue?vue&type=script&lang=js&"
export * from "./BlogPostEdit.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostEdit.vue?vue&type=style&index=0&id=d4919b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4919b80",
  null
  
)

export default component.exports